import { addNavMenuItem, addNavMenuSection } from "@bb-vendure/admin-ui/core";

export default [
  addNavMenuItem(
    {
      id: "package-list",
      label: "nav.package-waiting-list",
      routerLink: ["/extensions/package-waiting"],
      icon: "truck",
      requiresPermission: (userPermissions) => {
        return userPermissions.includes("ReadPackage");
      },
    },
    "package-review"
  ),
  addNavMenuItem(
    {
      id: "package-request",
      label: "nav.package-pushed-list",
      routerLink: ["/extensions/package-pushed"],
      icon: "truck",
      requiresPermission: (userPermissions) => {
        return userPermissions.includes("ReadPackage");
      },
    },
    "package-review"
  ),
  addNavMenuItem(
    {
      id: "shipment-requested",
      label: "nav.shipment-requested-list",
      routerLink: ["/extensions/shipment-requested"],
      icon: "ferry",
      requiresPermission: (userPermissions) => {
        return userPermissions.includes("ReadPackage");
      },
    },
    "shipping-section"
  ),
  addNavMenuItem(
    {
      id: "shipment-completed",
      label: "nav.shipment-completed-list",
      routerLink: ["/extensions/shipment-completed"],
      icon: "ferry",
      requiresPermission: (userPermissions) => {
        return userPermissions.includes("ReadPackage");
      },
    },
    "shipping-section"
  ),
];
